import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserRole } from 'generated/graphql';
import { selectCurrentCampaign } from '../campaign-context/campaign-context-selectors';

import { AuthState, StateName } from './auth-state';

export const selectAuth = createFeatureSelector<AuthState>(StateName);

export const selectCurrentUser = createSelector(selectAuth, (state) => state.current_user);

export const selectPasswordResetMessage = createSelector(selectAuth, (state) => state.password_reset_message);

export const selectSpecializedExportingEnabled = createSelector(selectCurrentUser, selectCurrentCampaign, (
  currentUser,
  currentCampaign
) => {
  if (!currentUser || !currentCampaign) {
    console.warn('selectSpecializedExportingEnabled: currentUser or currentCampaign is null');
    return false;
  }
  const user = currentUser;
  const campaign = currentCampaign;
  if (user.role === UserRole.Activist) {
    return false;
  }
  if (user.role === UserRole.Organizer ) {
    return !campaign.restrictedExportingSettings.specializedExportsDisabled;
  }

  return true;
});
